<p>REGISTER</p>
<form
  class="registration-form"
  [formGroup]="registrationForm"
  (ngSubmit)="onSubmitRegistration()"
>
  <label for="username">username: </label>
  <input id="username" type="text" formControlName="username" required />
  <label for="password">password: </label>
  <input id="password" type="password" formControlName="password" required />
  <label for="email">email: </label>
  <input id="email" type="text" formControlName="email" required />
  <button type="submit">Submit</button>
</form>
